import React from "react";
import { PageHero } from "@/components/site/ui";
import { Reveal } from "@/components/brand";
import { GALLERY, SIGNATURE } from "@/constants/media";

export default function Gallery() {
  return (
    <div>
      <PageHero eyebrow="The Property" title="Gallery" subtitle={SIGNATURE} />
      <div className="max-w-6xl mx-auto px-6 py-20">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {GALLERY.map((g, i) => (
            <Reveal key={i} delay={(i % 3) * 0.06} className="mb-5 break-inside-avoid">
              <div className="group relative overflow-hidden rounded-lg glass" data-testid={`gallery-img-${i}`}>
                <img src={g.src} alt={g.caption} className={`w-full object-cover ${g.tall ? "h-[520px]" : "h-72"} group-hover:scale-105 transition-transform duration-700`} />
                <div className="absolute inset-0 bg-gradient-to-t from-ink/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-5">
                  <span className="text-sm text-foreground/90 font-serif italic">{g.caption}</span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
